import { BaseService } from "./../base";
export class ConvprevService extends BaseService {
  static get entity() {
    return "convprev";
  }
  static get name() {
    return "convprev";
  }

  static async getAll() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }

  static async getByIntPrevId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find/${id}`, this.name);
  }
}
